import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { AlertMessageComponent } from '../alert-message/alert-message.component';

/**
 * FCR 19.1 Suspected Misuse — persistent stack of top warning banners on the Cart page.
 *
 * Renders one warning per message (AC13: up to 2 messages reflecting AC06 auto-remove and
 * AC07 auto-adjust). Unlike the transient app snackbar, this list is persistent so the
 * validation survives reopening the Cart (AC12). Presentation only — the parent supplies the
 * message list; the limit logic is wired separately.
 */
@Component({
  selector: 'lib-cart-warning-banners',
  templateUrl: './cart-warning-banners.component.html',
  styleUrl: './cart-warning-banners.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AlertMessageComponent],
})
export class CartWarningBannersComponent {
  /** Warning messages to display, in order. Empty array renders nothing. */
  messages = input<string[]>([]);
}
